import axios from 'axios'

export default {
  // 获取工单模版的信息
  orderTmplDetail(params) {
    return axios.get('/api/rendering/admin/base/danxiaoer/tmpl/orderTmplDetail', { params })
  },
  // 创建工单
  createTicket(params) {
    return axios.post('/api/rendering/admin/base/danxiaoer/order/create', params)
  },
  // 获取员工列表
  getStaffList(params) {
    return axios.get('/api/rendering/admin/base/danxiaoer/user/list', params)
  },
  // 获取抄送列表
  getCcList(params) {
    return axios.post('/api/rendering/admin/base/danxiaoer/CCPerson', params)
  },
  // 上传文件
  uploadFile(params) {
    return axios.post('/api/rendering/admin/base/danxiaoer/upload/save', params, {
      headers: {
        'content-type': 'multipart/form-data;',
      },
    })
  },
  copyOrder(params) {
    return axios.post('/api/rendering/admin/base/danxiaoer/copyOrder', params)
  },
  // 校验是否开过工单
  createOrderPreVerify(params) {
    return axios.post('/api/rendering/admin/base/danxiaoer/order/createOrderPreVerify', params)
  },
  // 发送工单参数到客服工单系统获取跳转链接
  getTicketRedirectUrl(params) {
    return axios.post('/api/rendering/admin/base/danxiaoer/order/sendWorkOrderInfoToRtickets', params)
  },
}
